import { pdpTradeDesignManagerOnboardingRule } from '../../../global/tradeOnboarding/tradeOnboardingRules';

import {
    PRIORITIES,
    SHOW_PDP_TRADE_DESIGN_MANAGER_ONBOARDING,
} from '../pdpSharedNotificationConstants';

export const pdpSharedNotificationTradeDesignManagerOnboardingModalConfig = {
    name: 'pdpTradeDesignManagerOnboardingModal',
    priority: PRIORITIES.PDP_TRADE_DESIGN_MANAGER_ONBOARDING,
    rule: pdpTradeDesignManagerOnboardingRule,
    action: () => dispatch =>
        dispatch({
            type: SHOW_PDP_TRADE_DESIGN_MANAGER_ONBOARDING,
        }),
};
